import type {Cause, CauseOnMessage} from "@prisma/client"
import type {Part} from "@ri2/rc-db"

import type {Message} from "../message/client"
import {brokenPartStatusId} from "../partStatusClient"

export const confirmationThreshold = 0.8
export const likelyThreshold = 0.6

export const isProbabilityConfirmed = (probability: number): boolean =>
  probability >= confirmationThreshold

export const isProbabilityLikely = (probability: number): boolean =>
  probability >= likelyThreshold

export const isCauseOnMessageConfirmed = (
  cause: CauseOnMessageWithCauseAndPart,
): boolean => isProbabilityConfirmed(cause.probability)

export const isCauseOnMessageLikely = (
  cause: CauseOnMessageWithCauseAndPart,
): boolean => isProbabilityLikely(cause.probability)

export const getConfirmedCausesFromMessage = (
  message: Message,
): CauseOnMessageWithCauseAndPart[] =>
  message.type === "ai" ? message.causes.filter(isCauseOnMessageConfirmed) : []

export const getLikelyCausesFromMessage = (
  message: Message,
): CauseOnMessageWithCauseAndPart[] =>
  message.type === "ai" ? message.causes.filter(isCauseOnMessageLikely) : []

export type CauseOnMessageWithCauseAndPart = CauseOnMessage & {
  cause: Cause
  part?: Part
}

export const isBrokenPartCause = ({
  partStatusId,
}: Pick<Cause, "partStatusId">): boolean => partStatusId === brokenPartStatusId
